var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-step"},[_c('Steps',{staticStyle:{"width":"75%"},attrs:{"current":_vm.current}},[_c('Step',{attrs:{"title":"选择门票"}}),_c('Step',{attrs:{"title":"填写信息"}}),_c('Step',{attrs:{"title":"预约完成"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }